module.exports = __webpack_public_path__ + "static/media/risk--mobile--2.a34857ec.png";